import ProfessionalTypeEnum from "@/enums/Administration/SMA/ProfessionalTypeEnum";

/**
 * Classe information client (Base)
 */
abstract class CustomerInfo {
    public Type: string;
}

// ---

/**
 * Classe information client particulier
 */
class ParticularCustomerInformation extends CustomerInfo {
    private lastName: string;
    private firstName: string;
    private phone: string;
    private email: string;
    private customerAddress: string;
    private customerZipcode: string;
    private customerCity: string;
    private birthday: string;

    constructor(data: any) {
        super();
        this.Type = "ParticularCustomerInformation";
        this.lastName = data.LastName ?? '';
        this.firstName = data.FirstName ?? '';
        this.phone = data.Phone ?? '';
        this.email = data.Email ?? '';
        this.customerAddress = data.CustomerAddress ?? '';
        this.customerZipcode = data.CustomerZipcode ?? '';
        this.customerCity = data.CustomerCity ?? '';
        this.birthday = data.Birthday ?? '';
    }

    public get LastName(): string { return this.lastName; }
    public get FirstName(): string { return this.firstName; }
    public get Phone(): string { return this.phone; }
    public get Email(): string { return this.email; }
    public get CustomerAddress(): string { return this.customerAddress; }
    public get CustomerZipcode(): string { return this.customerZipcode; }
    public get CustomerCity(): string { return this.customerCity; }
    public get Birthday(): string { return this.birthday; }

    public set LastName(value: string) {
        this.lastName = value;
    }

    public set FirstName(value: string) {
        this.firstName = value;
    }

    public set Phone(value: string) {
        this.phone = value;
    }
    
    public set Email(value: string) {
        this.email = value;
    }

    public set CustomerAddress(value: string) {
        this.customerAddress = value;
    }
    
    public set CustomerZipcode(value: string) {
        this.customerZipcode = value;
    }

    public set CustomerCity(value: string) {
        this.customerCity = value;
    }

    public set Birthday(value: string) {
        this.birthday = value;
    }
}

// ---

/**
 * Classe information client professionnel
 */
class ProfessionalCustomerInformation extends ParticularCustomerInformation {
    private companyName: string;
    private professionalType: ProfessionalTypeEnum;
    private siret: string;
    private address: string;
    private zipcode: string;
    private city: string;
    private function: string;

    constructor(data: any) {
        super(data);
        this.Type = "ProfessionalCustomerInformation";
        this.companyName = data.CompanyName ?? '';
        this.professionalType = data.ProfessionalType ?? ProfessionalTypeEnum.Undefined;
        this.siret = data.Siret ?? '';
        this.address = data.Address ?? '';
        this.zipcode = data.Zipcode ?? '';
        this.city = data.City ?? '';
        this.function = data.Function ?? '';
    }

    public get CompanyName(): string { return this.companyName; }
    public get ProfessionalType(): ProfessionalTypeEnum { return this.professionalType; }
    public get Siret(): string { return this.siret; }
    public get Address(): string { return this.address; }
    public get Zipcode(): string { return this.zipcode; }
    public get City(): string { return this.city; }
    public get Function(): string { return this.function; }

    public set CompanyName(value: string) {
        this.companyName = value;
    }

    public set ProfessionalType(value: ProfessionalTypeEnum) {
        this.professionalType = value;
    }

    public set Siret(value: string) {
        this.siret = value;
    }

    public set Address(value: string) {
        this.address = value;
    }

    public set Zipcode(value: string) {
        this.zipcode = value;
    }

    public set City(value: string) {
        this.city = value;
    }

    public set Function(value: string) {
        this.function = value;
    }
}

export {
    CustomerInfo,
    ParticularCustomerInformation,
    ProfessionalCustomerInformation
}